import { render } from "./ClanDetails.vue?vue&type=template&id=8a73a01a&scoped=true"
import script from "./ClanDetails.vue?vue&type=script&lang=js"
export * from "./ClanDetails.vue?vue&type=script&lang=js"

import "./ClanDetails.vue?vue&type=style&index=0&id=8a73a01a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a73a01a"]])

export default __exports__